import { render } from "./LiveclassAttendance.vue?vue&type=template&id=30e07a07&scoped=true"
import script from "./LiveclassAttendance.vue?vue&type=script&lang=js"
export * from "./LiveclassAttendance.vue?vue&type=script&lang=js"

import "./LiveclassAttendance.vue?vue&type=style&index=0&id=30e07a07&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e07a07"]])

export default __exports__